import { faPlain, toman } from 'utilities/helper/format'
import { SectionError } from 'components/states'
import DotsLoading from 'components/loadings/dotsLoading'
import { useCashboxWinners } from '../hooks'

interface Props {
    id?: string
    cashbox: ICashboxDetail
    search: string
}

export default function WinnersTab({ id, cashbox, search }: Props) {
    const { data, isLoading, isError, refetch } = useCashboxWinners(id, search)

    if (isLoading) return <DotsLoading />
    if (isError)
        return (
            <div className="p-4">
                <SectionError onRetry={() => refetch()} />
            </div>
        )

    const winners = data?.results ?? []

    if (winners.length === 0)
        return (
            <p className="text-sm text-text-secondary text-center py-10">
                هنوز قرعه‌کشی انجام نشده است
            </p>
        )

    return (
        <div className="px-4 py-3">
            <div className="rounded-card border border-divider bg-white overflow-hidden">
                {winners.map((w) => (
                    <div
                        key={w.id}
                        className="flex items-center justify-between px-3 py-3 border-b border-divider last:border-b-0"
                    >
                        <div className="min-w-0">
                            <p className="text-sm text-black truncate">
                                {w.name?.trim() || 'برنده بدون نام'}
                                {w.type === 'share_group' && (
                                    <span className="text-xs text-text-secondary mr-1">
                                        (گروه خرده‌سهم)
                                    </span>
                                )}
                            </p>
                            <p className="text-xs text-text-secondary mt-0.5">
                                نوبت {faPlain.format(w.cycle_index)}
                                {w.drawing_date ? ` · ${w.drawing_date}` : ''}
                            </p>
                        </div>
                        <p className="text-sm font-bold text-black shrink-0 pl-1">
                            {toman(w.loan_amount)}
                        </p>
                    </div>
                ))}
            </div>
            {cashbox.period?.last_winner_name && (
                <p className="text-xs text-text-secondary mt-3 text-center">
                    آخرین برنده: {cashbox.period.last_winner_name}
                </p>
            )}
        </div>
    )
}
